import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useEnroll } from "@/context/EnrollContext";

/**
 * EnrollDialog - intercepts any openEnroll() call and navigates
 * the user to the NiviLanding page ("/") where the AI chat is embedded.
 */
export const EnrollDialog = () => {
  const { open, setOpen } = useEnroll();
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setOpen(false);          // reset context state
      navigate("/chat");        // go to the Nivi chat landing page
    }
  }, [open, setOpen, navigate]);

  return null; // nothing to render
};
